import { isMotionValue } from "motion-dom";
export function isWillChangeMotionValue(value) {
    return Boolean(isMotionValue(value) && value.add);
}
//# sourceMappingURL=is.js.map